import { render } from "./LibraryWork.vue?vue&type=template&id=788e4e48&scoped=true"
import script from "./LibraryWork.vue?vue&type=script&lang=js"
export * from "./LibraryWork.vue?vue&type=script&lang=js"

import "./LibraryWork.vue?vue&type=style&index=0&id=788e4e48&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788e4e48"]])

export default __exports__